export const environment = {
  production: true,
  apiUrlBase: 'https://scl-lcms-api-staging.azurewebsites.net',
  authServerUrlBase: 'https://scl-auth-staging.azurewebsites.net',
  apiUrlAiBase: 'https://sea-turtle-app-i3j52.ondigitalocean.app',
  newPayrollsYear: '2026-01-07',
  clientId: "LcmsWebApp",
  clientSecret: "LcmsWebApp",
  scopeId: 'apilcms',
  scopeSecret: 'apilcmsscope',
  scopes: 'openid offline_access profile email role read write delete IdentityServerApi'
};
